// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__6Qqg4","title":"Navbar_title__pQSLJ"};